const config = {
  inputLabel: 'fullScreenImageUrl',
  key: 'fullscreenimageurl',
  inputType: 'textfield',
};

export default config;
